import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '@sia/shared';

@Injectable({
  providedIn: 'root',
})
export class SiaAIPromptApi {
  #http = inject(SiaHttpService);

  private readonly aiPromptController: string = 'chat-ai';

  applyPrompt(promptId: number, parameters: any): Promise<string> {
    return this.#http.post(
      `${this.aiPromptController}/prompt/${promptId}`,
      parameters,
    );
  }
}
